import { getAxisValueBySide } from '../../Visualization/objectControls';

export const getWallLength = (configuration, object) =>
  getAxisValueBySide({ x: configuration.length, z: configuration.width }, object.side);

export const getSegmentsWidth = (configuration, object) =>
  getAxisValueBySide(
    { x: configuration.xWallSegmentsWidth, z: configuration.zWallSegmentsWidth },
    object.side
  );

export const getWallSegmentIndexAtPosition = (configuration, object) => {
  const wallSegmentsWidth = getSegmentsWidth(configuration, object);
  if (!wallSegmentsWidth || !object.absoluteOffset) {
    if (Number.isInteger(object.index)) {
      return object.index;
    }
    return null;
  }
  const length = getWallLength(configuration, object);
  const x = object.centerOffsetX || 0;
  let pos = -length * 0.5;
  for (let i = 0; i < wallSegmentsWidth.length; i++) {
    pos += wallSegmentsWidth[i];
    if (pos >= x) {
      return i;
    }
  }
  return wallSegmentsWidth.length - 1;
};
